// import { mock, fetch } from './fetch';
import { loadModules } from 'esri-loader';

const { 
    REACT_APP_BASE_URL_GIS_SERVER } = window['runConfig'];


export const getListDMA = (token, whereClause) => {

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_DMA_NRW_V1/FeatureServer/1/Query`;

            const bodyFormData_getListDMA = new FormData();
            bodyFormData_getListDMA.set('f', 'json')
            bodyFormData_getListDMA.append('outFields', 'OBJECTID, DMAID');
            bodyFormData_getListDMA.append('where', '1=1');
            bodyFormData_getListDMA.append('returnGeometry', 'false');
            bodyFormData_getListDMA.append('orderByFields', 'DMAID');
            bodyFormData_getListDMA.append('token', `${token}`);
 
            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_getListDMA,
            })

        });

    return res;
}

// export const getListDMA = (token, whereClause) => {

//     const bodyFormData = new FormData();
//     bodyFormData.set('f', 'json')
//     bodyFormData.append('outFields','OBJECTID, DMAID');
//     bodyFormData.append('where', '1=1')
//     bodyFormData.append('returnGeometry','false');
//     bodyFormData.append('orderByFields','DMAID');
//     bodyFormData.append('token', `${token}`);
//     const config_token = {headers: {
//         'Authorization': `Bearer ${token}`
//     }}
//     return fetch.post('arcgis/rest/services/Serian/DMA_NRW_V2/FeatureServer/0/Query', bodyFormData,config_token)
// }
